import React, { useRef, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Box,
  Typography,
} from '@mui/material';
import {
  Campaign as CampaignIcon,
  Public as PublicIcon,
  AttachMoney as AttachMoneyIcon,
  Business as BusinessIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
export default function TCampanas(props) {
  const mounted = useRef(true);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const rows = props.rows;
  const term = props.termc;
  const history = useHistory();
  const abrirPerfilCampana = (campana) => {
    history.push({ pathname: '/modificarCampana', state: campana });
  };
  useEffect(() => {
    return function cleanup() {
      mounted.current = false;
    };
  }, [rows]);
  function searchingTermc(term) {
    return function (x) {
      let estado = '';
      if (x.estadocampana === null) {
        estado = '';
      } else {
        estado = x.estadocampana;
      }
      let tipocampana = '';
      if (x.tipocampana.descritipocampana === null) {
        tipocampana = '';
      } else {
        tipocampana = x.tipocampana.descritipocampana;
      }
      let descricampana = '';
      if (x.descricampana === null) {
        descricampana = '';
      } else {
        descricampana = x.descricampana;
      }
      let codcampana = 0;
      if (x.codcampana === null) {
        codcampana = 0;
      } else {
        codcampana = x.codcampana;
      }
      return (
        descricampana.toLowerCase().includes(term.toLowerCase()) ||
        tipocampana.toLowerCase().includes(term.toLowerCase()) ||
        estado.toLowerCase().includes(term.toLowerCase()) ||
        codcampana.toString().toLowerCase().includes(term.toLowerCase()) ||
        !term
      );
    };
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <Box sx={{ width: '100%' }}>
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CampaignIcon sx={{ fontSize: 18 }} />
                  Campaña
                </Box>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                Tipo
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                Detalles
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                Objetivos
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <AttachMoneyIcon sx={{ fontSize: 18 }} />
                  Presupuesto
                </Box>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <BusinessIcon sx={{ fontSize: 18 }} />
                  Empresa
                </Box>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <PublicIcon sx={{ fontSize: 18 }} />
                  Geografía
                </Box>
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                Estado
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .filter(searchingTermc(term))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((campana) => (
                <TableRow
                  key={campana.campanA_Id}
                  sx={{
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                    '&:nth-of-type(even)': {
                      backgroundColor: 'action.hover',
                    },
                  }}
                >
                  <TableCell align="left">
                    <Typography variant="body2" fontWeight={600}>
                      {campana.descricampana}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="body2">
                      {campana.tipocampana.descritipocampana}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="body2">{campana.numcampana}</Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="body2">{campana.objetivos}</Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="body2" fontWeight={600} color="success.main">
                      {Intl.NumberFormat('es').format(campana.presupuesto)}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="body2">
                      {campana.empresacontratada}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="body2">{campana.geografia}</Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {campana.estadocampana === 'Activo' ? (
                        <CheckCircleIcon sx={{ fontSize: 20, color: 'success.main' }} />
                      ) : (
                        <CancelIcon sx={{ fontSize: 20, color: 'error.main' }} />
                      )}
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        color={campana.estadocampana === 'Activo' ? 'success.main' : 'error.main'}
                      >
                        {campana.estadocampana}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell align="left">
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      onClick={() => abrirPerfilCampana(campana)}
                      sx={{
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                      }}
                    >
                      Modificar
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
        }
      />
    </Box>
  );
}
